export default __webpack_public_path__ + "static/media/qrmaster-screenshot-02.900cc779.png";